{
  "basicInfoFields": {
    "max": "Last name must be 50 characters or fewer.",
    "max2": "First name must be 50 characters or fewer.",
    "katakana": "Last name (phonetic) must be in full-width katakana.",
    "max3": "Last name (phonetic) must be 50 characters or fewer.",
    "katakana2": "First name (phonetic) must be in full-width katakana.",
    "max4": "First name (phonetic) must be 50 characters or fewer.",
    "enqueueSnackbar": "Basic information updated",
    "enqueueSnackbar2": "The basic information couldn't be updated.",
    "label": "Last name",
    "label2": "First name",
    "label3": "Last name (phonetic)",
    "label4": "First name (phonetic)"
  },
  "emailFields": {
    "required": "Enter an email address.",
    "email": "Enter a valid email address.",
    "message": "An account with this email address already exists.",
    "enqueueSnackbar": "Verification code sent",
    "enqueueSnackbar2": "The verification code couldn't be sent.",
    "label": "Email address",
    "text": "When you update, a verification code is sent to the new email address.",
    "text2": "The new email address isn't active until verification is complete.",
    "samlLocked": "The email address can't be changed for a tenant with SSO enabled. To change it, contact your administrator."
  },
  "loginNotificationFields": {
    "enqueueSnackbar": "The tenant information couldn't be retrieved.",
    "enqueueSnackbar2": "Sign-in notification email setting updated",
    "enqueueSnackbar3": "The sign-in notification email setting couldn't be updated.",
    "text": "Send a notification email to my email address when I sign in (protects against unauthorized logins)",
    "text2": "When enabled, an email notification is sent each time you sign in"
  },
  "passwordFields": {
    "required": "Enter the current password.",
    "required2": "Enter a new password.",
    "enqueueSnackbar": "Password updated. Sign in again with the new password.",
    "enqueueSnackbar2": "The password couldn't be updated.",
    "label": "Current password",
    "label2": "New password"
  },
  "accountSettings": {
    "label": "Basic information",
    "label2": "Email address",
    "label3": "Password",
    "label4": "Notifications",
    "title": "Account settings",
    "text": "Updating...",
    "title2": "Account information"
  },
  "verificationCodeForm": {
    "required": "Enter the verification code.",
    "enqueueSnackbar": "Email address updated",
    "message": "The verification code is incorrect.",
    "message2": "The maximum number of attempts was exceeded. Try again later.",
    "message6": "An account with this email address already exists.",
    "enqueueSnackbar2": "The email address couldn't be updated.",
    "text": "Enter email verification code",
    "text2": "A verification code was sent to the new email address.",
    "text3": "The verification code expires in 24 hours.",
    "text4": "Verify",
    "samlLocked": "The email address can't be changed for a tenant with SSO enabled. To change it, contact your administrator."
  }
}
